document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  const style = document.createElement('style');

  style.textContent = `
  .product-card .product-card__image {
    transition: opacity 0.6s ease !important;
  }

  .product-card .product-card__image--secondary {
    display: block !important;
    opacity: 0 !important;
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    transition: opacity 0.6s ease !important;
  }

  .product-card.mobile-hover-active .product-card__image--secondary {
    opacity: 1 !important;
  }

  .product-card.mobile-hover-active
  .product-card__image:not(.product-card__image--secondary) {
    opacity: 0 !important;
  }
`;

  document.head.appendChild(style);

  document.addEventListener('click', (event) => {
    const figure = event.target.closest('.product-card__figure');
    const card = event.target.closest('.product-card');

    if (!figure || !card) {
      document
        .querySelectorAll('.product-card.mobile-hover-active')
        .forEach((item) => item.classList.remove('mobile-hover-active'));
      return;
    }

    const secondaryImage = card.querySelector(
      '.product-card__image--secondary'
    );

    if (!secondaryImage) return;

    if (!card.classList.contains('mobile-hover-active')) {
      event.preventDefault();

      document
        .querySelectorAll('.product-card.mobile-hover-active')
        .forEach((item) => {
          if (item !== card) {
            item.classList.remove('mobile-hover-active');
          }
        });

      card.classList.add('mobile-hover-active');
    }
  });
});